import { map, pipe, toPairs, reduce, keys, all, equals, curry } from 'ramda';
import { isUndefined, omitBy } from 'ramda-adjunct';
export const sameValuesEntries = (objects) => reduce((acc, key) => {
    const values = map((obj) => obj[key], objects);
    if (all(equals(values[0]), values) && values[0] !== undefined) {
        acc[key] = values[0];
    }
    return acc;
}, {}, keys(objects[0]));
export const omitDefaultValues = curry((defaultValues, values) => omitBy((value, key) => equals(value, defaultValues[key]), values));
// <T extends Record<string, unknown>>(objects: T[]): Partial<T>[] =>
export const toModificatoins = (columns) => {
    // Create a map from fieldKey to fieldName
    const fieldKeyToFieldName = new Map();
    columns.forEach((column) => {
        fieldKeyToFieldName.set(column.fieldKey, column.fieldName);
    });
    return (values) => {
        return pipe(omitBy(isUndefined), toPairs, map(([fieldKey, value]) => {
            // Convert fieldKey to fieldName for API
            const fieldName = fieldKeyToFieldName.get(fieldKey) ?? fieldKey;
            return { columnName: fieldName, value };
        }))(values);
    };
};
//# sourceMappingURL=helpers.js.map